module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dots"
  }, _vm._l(([0, 1, 2]), function(idx) {
    return _c('div', {
      staticClass: "loading-dots__dot",
      class: ("loading-dots__dot--" + idx)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0957a7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/loaderDots/LoaderDots.vue
// module id = 1982
// module chunks = 0